interface CookieConsentProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

export default function CookieConsent({ isOpen, onAccept, onDecline }: CookieConsentProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 dark:bg-gray-800">
        <h2 className="mb-4 text-2xl font-bold text-gray-900 dark:text-gray-100">Cookie Consent</h2>
        <p className="mb-6 text-gray-700 dark:text-gray-300">
          We use cookies to create and manage your playlists. This helps us associate you with the playlists you create and allows you to manage them. The cookie is randomly generated and does not contain any personal information.
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onDecline}
            className="rounded bg-gray-200 px-4 py-2 text-gray-800 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
          >
            Decline
          </button>
          <button
            onClick={onAccept}
            className="rounded bg-primary px-4 py-2 text-white hover:bg-secondary"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
} 